import React from "react";
import HUMAN_PROFILE from "../../assets/images/FileAnalyzer/human-profile.svg";

function NotFoundFiles({ heading, discription, message }) {
  return (
    <div className="align-items-center contentsection d-flex justify-content-center text-center">
      {/* <h2 className="subheading">{heading}</h2>
      <p>{discription}</p> */}

      <div className="nodata">
        <div className="nodata-img">
          <img src={HUMAN_PROFILE} alt="" />
        </div>

        <h4 className="px-4">{message}</h4>
      </div>
    </div>
  );
}

export default NotFoundFiles;